import React from 'react'
import './CategoryChip.css'

export interface CategoryChipProps {
  label: string
  className?: string
}

export const CategoryChip: React.FC<CategoryChipProps> = ({
  label,
  className = '',
}) => {
  return (
    <div className={`category-chip ${className}`}>
      <span className="category-chip-label">{label}</span>
    </div>
  )
}
